export enum ShapeDrawConfiguration {
  CreateIndividualProximity = 'CreateIndividualProximity',
}

// this tool is not necessarily limited to circles, more shapes can be added
// the support for them then needs to be added to useShapeDrawFinished and ShapeDrawOverlay
export enum ShapeDrawShape {
  Circle = 'Circle',
}

export type ShapeDrawState = Readonly<{
  isActive: false;
  shape?: undefined;
  configuration?: undefined;
} | {
  isActive: true;
  shape: ShapeDrawShape;
  configuration: ShapeDrawConfiguration;
}>;
